import { type ComponentType } from 'react';
import { BigIdeaSlide } from './components/slides/BigIdeaSlide';
import { ProblemSlide } from './components/slides/ProblemSlide';
import { PromiseSlide } from './components/slides/PromiseSlide';
import { FormatSlide } from './components/slides/FormatSlide';
import { ProofSlide } from './components/slides/ProofSlide';
import { OperatingModelSlide } from './components/slides/OperatingModelSlide';
import { PortfolioSlide } from './components/slides/PortfolioSlide';
import { StoryMethodSlide } from './components/slides/StoryMethodSlide';
import { RhythmSlide } from './components/slides/RhythmSlide';
import { EcosystemSlide } from './components/slides/EcosystemSlide';
import { StartSlide } from './components/slides/StartSlide';
import { AmbitionSlide } from './components/slides/AmbitionSlide';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_8hhe5u',
  title: 'Time with Solventum pays back',
  component: BigIdeaSlide
}, {
  id: 'scr_prb002',
  title: 'HCP attention is expensive',
  component: ProblemSlide
}, {
  id: 'scr_prm003',
  title: 'Give us a little time',
  component: PromiseSlide
}, {
  id: 'scr_fmt004',
  title: 'The countdown becomes the signal',
  component: FormatSlide
}, {
  id: 'scr_prf005',
  title: 'Same contract. Different reward',
  component: ProofSlide
}, {
  id: 'scr_amb006',
  title: 'From campaigns to a Solventum habit',
  component: AmbitionSlide
}, {
  id: 'scr_opm007',
  title: 'Now we make it real',
  component: OperatingModelSlide
}, {
  id: 'scr_prt008',
  title: 'Where does Solventum have something worth 30 seconds?',
  component: PortfolioSlide
}, {
  id: 'scr_stm009',
  title: 'Don’t tell experts what they already know',
  component: StoryMethodSlide
}, {
  id: 'scr_rhy010',
  title: 'A year of small investments',
  component: RhythmSlide
}, {
  id: 'scr_eco011',
  title: 'The campaign is not the channel',
  component: EcosystemSlide
}, {
  id: 'scr_srt012',
  title: 'What do we need to make this happen?',
  component: StartSlide
}];